(function () {
  document.documentElement.classList.add('js');

  // Collection sort: reload with ?sort_by=
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Close the mobile menu when a link inside it is used, or Escape is pressed
  document.querySelectorAll('.menu-drawer').forEach(function (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) drawer.removeAttribute('open');
    });
    drawer.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') {
        drawer.removeAttribute('open');
        var s = drawer.querySelector('summary');
        if (s) s.focus();
      }
    });
  });

  // Product variant picker
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idSelect = form.querySelector('select[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var button = form.querySelector('[data-add-button]');
    var buttonLabel = form.querySelector('[data-add-label]');
    var gallery = document.querySelector('[data-gallery]');
    var colourIndex = (product.options || []).findIndex(function (o) {
      var name = (typeof o === 'string' ? o : (o && o.name) || '').toLowerCase();
      return name.indexOf('colo') !== -1;
    });
    var colours = [];
    if (colourIndex > -1) {
      product.variants.forEach(function (v) {
        var c = String(v.options[colourIndex]).toLowerCase();
        if (colours.indexOf(c) === -1) colours.push(c);
      });
    }
    var lastColour = null;

    function syncGallery(variant) {
      if (!gallery) return;
      var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]'));
      if (colourIndex > -1) {
        var col = String(variant.options[colourIndex]).toLowerCase();
        items.forEach(function (item) {
          var alt = item.getAttribute('data-alt') || '';
          var mine = alt.indexOf(col) !== -1;
          var other = colours.some(function (c) { return c !== col && alt.indexOf(c) !== -1; });
          item.hidden = other && !mine;
        });
        if (col === lastColour) return;
        lastColour = col;
      }
      if (variant.featured_media) {
        var lead = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (lead) { lead.hidden = false; gallery.insertBefore(lead, gallery.firstChild); }
      }
      if (gallery.scrollLeft) gallery.scrollTo({ left: 0, behavior: 'smooth' });
    }
    (function () {
      var first = product.variants.find(function (v) { return String(v.id) === (idSelect && idSelect.value); });
      if (first && colourIndex > -1) lastColour = String(first.options[colourIndex]).toLowerCase();
    })();
    var money = function (cents) {
      var fmt = (window.KevTheme && window.KevTheme.moneyFormat) || '£{{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    };

    function selectedOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-group]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
      if (!variant) {
        if (button) button.disabled = true;
        if (buttonLabel) buttonLabel.textContent = 'Unavailable';
        return;
      }
      if (idSelect) idSelect.value = variant.id;
      syncGallery(variant);
      if (priceEl) {
        var html = money(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ' <s>' + money(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (button) button.disabled = !variant.available;
      if (buttonLabel) buttonLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-group]')) update();
    });
  });
})();
